import React from "react";

const Location = () => {
  return (
    <section className="location-section" id="location">
  

      <div className="location-map-wrapper">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3825.93050171749!2d80.69732907514467!3d16.47905638426139!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a35fba51dc1e1df%3A0x979ea54b1a75cd!2sSeven%20Days%20Cafe%20-%20Tadigadapa!5e0!3m2!1sen!2sin!4v1749312309494!5m2!1sen!2sin"
          width="100%"
          height="450"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </section>
  );
};

export default Location;
